import React from 'react'
import classNames from 'classnames'

export default function AvatarWrapper (props) {
  const {
    children,
    classes = null,
    className,
    large = false,
    active = false,
    margin = 'mr-4'
  } = props

  const wrapperClassNames = classNames(
    'avatar-circle',
    'bg-primary-500',
    'flex',
    'items-center',
    'rounded-full',
    'relative',
    { 'w-12 h-12': large === false },
    { 'w-16 h-16': large },
    'flex-shrink-0',
    margin,
    classes,
    className
  )

  const innerClassNames = classNames(
    'overflow-hidden',
    'flex',
    'items-center',
    'rounded-full',
    { 'w-12 h-12': large === false },
    { 'w-16 h-16': large },
  )

  return (
    <div className={wrapperClassNames}>
      <div className={innerClassNames}>
        {children}
      </div>
      {active && <span class="absolute bottom-0 right-0 block h-3.5 w-3.5 rounded-full border-2 border-white bg-available" />}
    </div>
  )
}
